/**
 * @generated SignedSource<<c22a8773a4c94a6d083b02ef971eb34f>>
 * @relayHash 6c8bbff92427f8f13a9f68ade35e1315
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a614603202abfb55d7d7de64c2578f6deaab7e80d00892134b1cea54b0b6ade8

import type { ConcreteRequest } from 'relay-runtime';
export type getForgeApp_appByIdQuery$variables = {
  appAri: string;
  contextIds: ReadonlyArray<string>;
};
export type getForgeApp_appByIdQuery$data = {
  readonly app: {
    readonly installationsByContexts: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly appEnvironmentVersion: {
            readonly extensions: {
              readonly nodes: ReadonlyArray<{
                readonly extensionData: AGG$JSON;
              } | null> | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly name: string;
    readonly privacyPolicy: string | null;
    readonly termsOfService: string | null;
  };
};
export type getForgeApp_appByIdQuery = {
  response: getForgeApp_appByIdQuery$data;
  variables: getForgeApp_appByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contextIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "privacyPolicy"
},
v4 = {
  "kind": "ScalarField",
  "name": "termsOfService"
},
v5 = [
  {
    "kind": "Variable",
    "name": "contextIds",
    "variableName": "contextIds"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "extensionData"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getForgeApp_appByIdQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "App",
          "kind": "LinkedField",
          "name": "app",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "args": (v5/*: any*/),
              "concreteType": "AppInstallationByIndexConnection",
              "kind": "LinkedField",
              "name": "installationsByContexts",
              "plural": false,
              "selections": [
                {
                  "concreteType": "AppInstallationByIndexEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "AppInstallation",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "AppEnvironmentVersion",
                          "kind": "LinkedField",
                          "name": "appEnvironmentVersion",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "AppVersionExtensions",
                              "kind": "LinkedField",
                              "name": "extensions",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "AppVersionExtension",
                                  "kind": "LinkedField",
                                  "name": "nodes",
                                  "plural": true,
                                  "selections": [
                                    (v6/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getForgeApp_appByIdQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "app",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": (v5/*: any*/),
            "concreteType": "AppInstallationByIndexConnection",
            "kind": "LinkedField",
            "name": "installationsByContexts",
            "plural": false,
            "selections": [
              {
                "concreteType": "AppInstallationByIndexEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AppInstallation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AppEnvironmentVersion",
                        "kind": "LinkedField",
                        "name": "appEnvironmentVersion",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AppVersionExtensions",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AppVersionExtension",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v7/*: any*/)
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "a614603202abfb55d7d7de64c2578f6deaab7e80d00892134b1cea54b0b6ade8",
    "metadata": {},
    "name": "getForgeApp_appByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e93ae1f09519a9c62b2154493dddce01";

export default node;
